import { createFileRoute, redirect } from '@tanstack/react-router';

import { Splash } from '@/components/ui/Splash';
import {
  FEATURES,
  featureFlagsReady,
  hasFeature,
} from '@/features/feature-flags';
import { PeopleWiki } from '@/features/people-wiki';
import { Routes } from '@/types/routes';

export const Route = createFileRoute('/_authenticated/people-wiki/')({
  async beforeLoad() {
    await featureFlagsReady();

    if (hasFeature(FEATURES.PEOPLE_WIKI)) {
      return;
    }

    throw redirect({
      to: Routes.Chats as string,
      replace: true,
    });
  },
  pendingComponent: () => <Splash reason="route-pending-flags-ready" />,
  component: PeopleWiki,
});
